import PropTypes from 'prop-types';
import { useEffect } from 'react';
import {  useLocation } from 'react-router-dom';
// @mui
import { Box, Drawer, Typography,  Stack } from '@mui/material';

// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import loginImage from '../../../assets/rms/login.png'

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  // console.log(loggedUser)
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (

    <Box sx={{display:'flex', height:'100%', width:'100%'}}>
      <Box sx={{backgroundColor:'black', width:'90%',}} >
      <Stack sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%', height: '100%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant='h1' color={'white'}>RMS</Typography>
          </Box>
          <img src={loginImage} alt='logo' width={250} />
        </Stack>
      </Box>
      <Box sx={{
         backgroundColor:'white',
         width:'10%',
         borderLeft: '40px solid #000',
         borderBottom: theme => `calc(100vh - ${theme.spacing(1)}) solid transparent`, // Dynamic border bottom

         }} />
             </Box>

  );


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: '25%' },
        backgroundColor: '#fff'
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: '25%',
              bgcolor: '#fff',
              border:'none'
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: '90%', bgcolor: '#000', },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
